<template>
  <a-card :body-style="{ padding: 0, height: height + 87 + 'px', overflowY: 'auto' }">
    <a-collapse
      v-model:activeKey="viewKey"
      :bordered="false"
      class="collapses"
      style="background: rgb(255, 255, 255)"
    >
      <template #expandIcon="{ isActive }">
        <caret-right-outlined :rotate="isActive ? 90 : 0" />
      </template>
      <a-collapse-panel
        :key="'1'"
        :style="customStyle"
      >
        <template #header>
          <span style="font-weight: 700">{{ $t('个人视图') }}</span>
        </template>
        <template #extra>
          <a-tooltip>
            <template #title>{{ $t('个人视图管理') }}</template>
            <setting-outlined
              style="margin-right: 10px"
              @click.stop="editView('personal')"
            />
          </a-tooltip>
          <a-tooltip>
            <template #title>{{ $t('新建个人视图') }}</template>
            <plus-outlined @click.stop="addView('personal')" />
          </a-tooltip>
        </template>
        <a-table
          v-if="personData.length > 0"
          :columns="columns"
          :customRow="customRow"
          :dataSource="personData"
          :pagination="false"
          :showHeader="false"
          :size="'small'"
        >
          <template #bodyCell="{ column, record }">
            <div
              class="table"
              v-if="column.dataIndex === 'name'"
              style="width: 100%; cursor: pointer"
              @click="changeView(record)"
            >
              <a-tooltip
                :title="record.name"
                :color="appStore.primaryColor"
                placement="left"
                :destroyTooltipOnHide="true"
                :overlayStyle="{ maxWidth: '200px' }"
              >
                <div style="max-width: 130px; float: left; white-space: nowrap; overflow: hidden">
                  {{ record.name }}
                </div>
              </a-tooltip>
              <span
                class="num"
                style="float: right"
                :style="
                  currentViewObj.id === record.id ? { color: '#1890ff', fontWeight: 'bold' } : {}
                "
              >
                {{ record.num }}
              </span>
              <a-dropdown class="dropdown">
                <span
                  style="float: right; font-weight: 800"
                  @click.stop=""
                >
                  · · ·
                </span>
                <template #overlay>
                  <a-menu>
                    <a-menu-item v-if="!record.is_system || is_auth">
                      <a
                        href="javascript:;"
                        @click="handleSubmit(record, 'personal')"
                      >
                        {{ $t('编辑') }}
                      </a>
                    </a-menu-item>
                    <a-menu-item>
                      <a
                        href="javascript:;"
                        @click="handleShare(record)"
                      >
                        {{ $t('分享视图') }}
                      </a>
                    </a-menu-item>
                    <a-menu-item v-if="!record.is_system || is_auth">
                      <a
                        href="javascript:;"
                        @click="handleDelet(record)"
                      >
                        {{ $t('删除') }}
                      </a>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </div>
          </template>
        </a-table>
      </a-collapse-panel>
      <a-collapse-panel
        :key="'2'"
        :style="customStyle"
      >
        <template #header>
          <span style="font-weight: 700">{{ $t('公共视图') }}</span>
        </template>
        <template #extra>
          <a-tooltip>
            <template #title>{{ $t('公共视图管理') }}</template>
            <setting-outlined
              style="margin-right: 10px"
              @click.stop="editView('public')"
            />
          </a-tooltip>
          <a-tooltip>
            <template #title>{{ $t('新建公共视图') }}</template>
            <plus-outlined @click.stop="addView('public')" />
          </a-tooltip>
        </template>
        <a-table
          v-if="publicData.length > 0"
          :columns="columns"
          :customRow="customRow"
          :dataSource="publicData"
          :pagination="false"
          :showHeader="false"
          :size="'small'"
        >
          <template #bodyCell="{ column, record }">
            <div
              class="table"
              v-if="column.dataIndex === 'name'"
              style="width: 100%; cursor: pointer"
              @click="changeView(record)"
            >
              <a-tooltip
                :title="record.name"
                :color="appStore.primaryColor"
                placement="left"
                :destroyTooltipOnHide="true"
                :overlayStyle="{ maxWidth: '200px' }"
              >
                <div style="max-width: 130px; float: left; white-space: nowrap; overflow: hidden">
                  {{ record.name }}
                </div>
              </a-tooltip>
              <span
                class="num"
                style="float: right"
                :style="
                  currentViewObj.id === record.id ? { color: '#1890ff', fontWeight: 'bold' } : {}
                "
              >
                {{ record.num }}
              </span>
              <a-dropdown class="dropdown">
                <span
                  style="float: right; font-weight: 800"
                  @click.stop=""
                >
                  · · ·
                </span>
                <template #overlay>
                  <a-menu>
                    <a-menu-item v-if="!record.is_system || is_auth">
                      <a
                        href="javascript:;"
                        @click="handleSubmit(record, 'public')"
                      >
                        {{ $t('编辑') }}
                      </a>
                    </a-menu-item>
                    <a-menu-item>
                      <a
                        href="javascript:;"
                        @click="handleShare(record)"
                      >
                        {{ $t('分享视图') }}
                      </a>
                    </a-menu-item>
                    <a-menu-item v-if="!record.is_system || is_auth">
                      <a
                        href="javascript:;"
                        @click="handleDelet(record)"
                      >
                        {{ $t('删除') }}
                      </a>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </div>
          </template>
        </a-table>
      </a-collapse-panel>
    </a-collapse>
  </a-card>
</template>

<script lang="ts">
import {
  computed,
  createVNode,
  defineComponent,
  onActivated,
  onMounted,
  onUnmounted,
  PropType,
  reactive,
  ref,
  watch,
} from 'vue';
import {
  CaretRightOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
  SettingOutlined,
} from '@ant-design/icons-vue';
import modalBox from 'liyu-pc-base/components/form-modal/modal-tools';
import { message, Modal } from 'ant-design-vue';
import { useUserStore } from 'liyu-pc-base/init-plugin';
import { useAppStore } from 'liyu-pc-base/init-plugin';
import {
  change_view_settings_sort,
  create_view_settings,
  delete_view_settings,
  query_view_settings_list,
  refresh_view_settings_cache,
  set_view_settings_default,
  update_view_settings,
} from 'liyu-pc-base/api/view-model';
import { sourceStore } from 'liyu-pc-base/init-plugin';
import { copyValue } from 'liyu-pc-base/utils/function';
import { getApiData } from 'liyu-pc-base/api/api-model';
import { getPageConfig } from 'liyu-pc-base/components/remotePages/index';
import { useI18n } from 'vue-i18n';
import { useRequiredConditionStore } from 'liyu-pc-base/init-plugin';
import { required_condition_event_obj } from 'liyu-pc-base/init-plugin';
import { useEnv } from 'liyu-pc-base/init-plugin';
import { CUSTOM_VIEW_DATA_USER } from 'liyu-pc-base/constants';

const VIEW_SYSTEM_EDIT = 'view_system_edit';
const columns = [
  {
    title: '',
    dataIndex: 'name',
    key: 'name',
  },
];
export default defineComponent({
  name: 'ViewManage',
  components: {
    CaretRightOutlined,
    PlusOutlined,
    SettingOutlined,
  },
  props: {
    currentViewObj: {
      type: Object,
      required: true,
    },
    menu_flag: {
      type: String,
      required: true,
    },
    menu_name: {
      type: String,
      required: true,
    },
    countData: {
      type: String,
      required: true,
    },
    create_num: {
      type: Number,
      required: true,
    },
    current_num: {
      type: Number,
      required: true,
    },
    count_num: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    modalType: {
      type: String,
    },
    app_flag: {
      type: String,
    },
    allBaseConfigMap: {
      type: Object,
      required: true,
    },
    searchConfigFields: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },
  emits: ['change'],
  setup(props, { emit }) {
    const env = useEnv();
    const requiredConditionStore = useRequiredConditionStore();
    const userStore = useUserStore();
    const appStore = useAppStore();
    const current_org = userStore.currentOrg;
    const userid = userStore.userid;
    const is_auth = ref(userStore.CHECK_AUTH(VIEW_SYSTEM_EDIT));
    const viewData = ref([]); // 视图数据
    const { t } = useI18n();
    let mergedConfig: any;
    const personData = computed(() => {
      const list = viewData.value
        .filter((item: any) => !!item.user_id && item.is_system)
        .map((item: any) => {
          return item;
        })
        .sort((a, b) => (a.sort == b.sort ? a.id - b.id : a.sort - b.sort));
      const list1 = viewData.value
        .filter((item: any) => !!item.user_id && !item.is_system)
        .map((item: any) => {
          return item;
        })
        .sort((a, b) => (a.sort == b.sort ? a.id - b.id : a.sort - b.sort));
      return list.concat(list1);
    }); // 个人视图数据
    const publicData = computed(() => {
      const list = viewData.value
        .filter((item: any) => !item.user_id && item.is_system)
        .map((item: any) => {
          return item;
        })
        .sort((a, b) => (a.sort == b.sort ? a.id - b.id : a.sort - b.sort));
      const list1 = viewData.value
        .filter((item: any) => !item.user_id && !item.is_system)
        .map((item: any) => {
          return item;
        })
        .sort((a, b) => (a.sort == b.sort ? a.id - b.id : a.sort - b.sort));
      return list.concat(list1);
    }); // 公共视图数据
    const viewNameList = computed(() => {
      return viewData.value.map((item: any) => {
        return item.name;
      });
    }); // 视图名称列表，用于创建、修改时查重
    const filterConditions = (conditions: any) => {
      const res = [];
      for (const group of conditions) {
        const group_item = [];
        for (const item of group) {
          if (props.allBaseConfigMap[item.field_name]) {
            group_item.push(item);
          }
        }
        if (group_item.length > 0) {
          res.push(group_item);
        }
      }
      return res;
    };
    const filter_search_model = (search_model: any) => {
      const res = {};
      const fieldMap = {};
      if (!search_model) {
        return res;
      }
      if (props.searchConfigFields?.length) {
        for (const item of props.searchConfigFields) {
          fieldMap[item.name] = item;
        }
      }
      for (const key of Object.keys(search_model)) {
        if (fieldMap[key]) {
          res[key] = search_model[key];
        }
      }
      return res;
    };
    const fetchData = async ({
      id,
      search_model,
      filter_map,
      sort_fields,
      group_condition,
      conditions,
      isShowGeneralFilter,
    }) => {
      return new Promise(resolve => {
        if (!props.countData && !mergedConfig?.countData) {
          console.error('无count接口');
          resolve(null);
        }
        const obj: any = {
          org_id: current_org.id,
          ...filter_search_model(search_model || {}),
          ...filter_map,
          sort_fields: sort_fields,
        };
        if (isShowGeneralFilter) {
          obj.group_condition = group_condition;
          obj.conditions = filterConditions(conditions);
        }
        obj.required_condition = getRequiredConditionObj();
        let db_alias = null;
        const page_config = getPageConfig(props.app_flag, props.modalType, null, t, {
          use_store: true,
          to_i18n: true,
          enable_btn: false,
        });
        if (page_config.get_db_alias) {
          db_alias = page_config.get_db_alias();
        }
        obj.db_alias = db_alias;
        getApiData(obj, mergedConfig?.countData ? mergedConfig.countData : props.countData)
          .then((res: any) => {
            viewData.value.forEach((item: any) => {
              if (item.id == id) {
                item.num = res;
              }
            });
            resolve(null);
          })
          .catch(error => {
            console.log('error', error);
            message.error(t('获取数据失败, 请刷新页面'));
          });
      });
    };
    const setCount = async (list: any) => {
      for (const item of list) {
        try {
          await fetchData(item);
        } catch (error) {
          console.log('error', error);
          message.error(t('获取数据失败, 请刷新页面'));
        }
      }
    };
    // 查询视图、刷新count
    const viewRefresh = async () => {
      const res = await getApiData(
        {
          org_id: current_org.id,
          user_id: userid,
          view_project__flag: env.VITE_APP_VIEW_PROJECT_FLAG,
          view_menu__flag: props.modalType,
          history_id: null,
          sort_fields: ['sort', 'create_time'],
          is_cache: false,
        },
        '/view/get_view_settings_for_user',
      );
      mergedConfig = getPageConfig(props.app_flag, props.modalType, null, t, {
        use_store: true,
        to_i18n: true,
        enable_btn: false,
      });
      if (mergedConfig?.isView === false) {
        window.location.hash = '';
        emit('change', null, {}, true, true);
        return;
      }
      requiredConditionStore.set_required_condition(
        props.modalType,
        mergedConfig.required_condition,
      );
      viewData.value.length = 0;
      let list: any = [];
      const count_search_list: any = [];
      if (res && res.system_user_datas && res.system_user_datas.length > 0) {
        list = list.concat(res.system_user_datas);
      }
      if (res && res.system_public_datas && res.system_public_datas.length > 0) {
        list = list.concat(res.system_public_datas);
      }
      if (res && res.public_datas && res.public_datas.length > 0) {
        list = list.concat(res.public_datas);
      }
      if (res && res.user_datas && res.user_datas.length > 0) {
        list = list.concat(res.user_datas);
      }
      list.forEach((item: any) => {
        let search_model: any = null;
        let filter_map: any = null;
        let group_condition: any = null;
        let conditions: any = null;
        if (item.data.isShowGeneralFilter) {
          search_model = {};
          filter_map = {};
          group_condition = item.data.group_condition;
          conditions = item.data.conditions;
        } else {
          search_model = item.data.search_model;
          filter_map = item.data.filter_map;
          group_condition = {};
          conditions = [];
        }
        viewData.value.push({
          ...item,
          search_model,
          filter_map,
          sort_fields: item.data.sort_fields,
          group_condition: group_condition,
          conditions: conditions,
        });
        count_search_list.push({
          id: item.id,
          isShowGeneralFilter: item.data.isShowGeneralFilter,
          search_model,
          filter_map,
          sort_fields: item.data.sort_fields,
          group_condition,
          conditions,
        });
      });
      if (count_search_list.length > 0) {
        setCount(count_search_list);
      }
      handleHashChange(null);
    };
    // 根据hash选定当前视图数据  event返回（视图数据，是否刷新页面，是否可自我保存）
    const handleHashChange = (uid: any) => {
      let hash = null;
      if (uid) {
        hash = uid;
      } else if (window.location.hash) {
        hash = window.location.hash.substring(1); // 去掉 # 符号
      }
      if (hash) {
        // 分享的视图链接打开
        const list = viewData.value.filter((item: any) => item.uid == hash);
        if (list && list.length > 0) {
          emit('change', null, { ...list[0], ...list[0].data }, true, true);
        } else {
          query_view_settings_list({
            org_id: current_org.id,
            conditions: [
              [
                {
                  field_name: 'is_active',
                  operator: 'in',
                  value: [true],
                  format: 'choices',
                  class_name: 'bool',
                },
                {
                  field_name: 'view_menu__flag',
                  operator: 'eq',
                  value: [props.menu_flag],
                  format: 'input',
                  class_name: 'str',
                },
                {
                  field_name: 'uid',
                  operator: 'eq',
                  value: [hash],
                  format: 'input',
                  class_name: 'str',
                },
              ],
            ],
          }).then((res: any) => {
            if (res && res.data && res.data.length > 0) {
              emit(
                'change',
                null,
                {
                  ...res.data[0],
                  ...res.data[0].data,
                },
                true,
                false,
              );
            } else {
              const list = viewData.value.filter((item: any) => !item.user_id && item.is_default);
              if (list && list.length > 0) {
                window.location.hash = list[0].uid;
                emit('change', null, { ...list[0], ...list[0].data }, true, true);
                return;
              }
              let obj = viewData.value
                .sort((a, b) => (a.sort == b.sort ? a.id - b.id : a.sort - b.sort))
                .find((item: any) => !item.user_id);
              if (obj && obj.uid) {
                window.location.hash = obj.uid;
                emit('change', null, { ...obj, ...obj.data }, true, true);
              } else {
                obj = viewData.value
                  .sort((a, b) => (a.sort == b.sort ? a.id - b.id : a.sort - b.sort))
                  .find((item: any) => item.user_id);
                if (obj && obj.uid) {
                  window.location.hash = obj.uid;
                  emit('change', null, { ...obj, ...obj.data }, true, true);
                } else {
                  const obj = {
                    uid: null,
                    view_menu__flag: props.menu_flag,
                    column: {},
                    search_model: {},
                    filter_map: {},
                    sort_fields: [],
                    filtered_value: {},
                    sort_orders: [],
                  };
                  emit('change', null, obj, true, false);
                  window.location.hash = '';
                }
              }
            }
          });
        }
      } else {
        let current_uid = '';
        if (sourceStore().get(CUSTOM_VIEW_DATA_USER)) {
          current_uid = sourceStore().get(CUSTOM_VIEW_DATA_USER)?.[props.menu_flag]; // 菜单当前视图uid
        }
        if (current_uid) {
          window.location.hash = current_uid;
          handleHashChange(current_uid);
        } else {
          // 优先选择非系统视图的默认视图
          const list = viewData.value.filter(
            (item: any) => !item.user_id && item.is_default && !item.is_system,
          );
          if (list && list.length > 0) {
            window.location.hash = list[0].uid;
            emit('change', null, { ...list[0], ...list[0].data }, true, true);
            return;
          }
          // 其次选择系统视图默认视图（多个默认选择第一个）
          const list_is_system = viewData.value.filter(
            (item: any) => !item.user_id && item.is_default && item.is_system,
          );
          if (list_is_system && list_is_system.length > 0) {
            window.location.hash = list_is_system[0].uid;
            emit('change', null, { ...list_is_system[0], ...list_is_system[0].data }, true, true);
            return;
          }
          let obj = viewData.value
            .sort((a, b) => (a.sort == b.sort ? a.id - b.id : a.sort - b.sort))
            .find((item: any) => !item.user_id);
          if (obj && obj.uid) {
            window.location.hash = obj.uid;
            emit('change', null, { ...obj, ...obj.data }, true, true);
          } else {
            obj = viewData.value
              .sort((a, b) => (a.sort == b.sort ? a.id - b.id : a.sort - b.sort))
              .find((item: any) => item.user_id);
            if (obj && obj.uid) {
              window.location.hash = obj.uid;
              emit('change', null, { ...obj, ...obj.data }, true, true);
            } else {
              window.location.hash = '';
              const obj = {
                uid: null,
                view_menu__flag: props.menu_flag,
                column: {},
                search_model: {},
                filter_map: {},
                sort_fields: [],
                filtered_value: {},
                sort_orders: [],
              };
              emit('change', null, obj, true, false);
            }
          }
        }
      }
    };
    const viewKey = ref(['1', '2']); // 视图数据展开控制key
    const customStyle =
      'background: #ffffff;border-radius: 4px;margin-bottom: 2px;border: 0;overflow: hidden;';
    const customRow = (record: any) => {
      return props.currentViewObj && record && record.id === props.currentViewObj.id
        ? { style: { backgroundColor: '#ddf1ff' } }
        : { style: {} };
    };
    // 切换视图
    const changeView = (record: any) => {
      window.location.hash = record.uid;
      handleHashChange(record.uid);
      refreshCount([record]);
    };
    const process_default_search_for_view = (data: any) => {
      const res = [];
      for (const gropu of data) {
        const group_item = [];
        for (const item of gropu) {
          group_item.push({
            field_name: item.field_name,
            format: item.format,
            operator: item.operator,
            class_name: item.class_name,
            value: item.value,
          });
        }
        res.push(group_item);
      }
      return res;
    };
    // 保存修改视图
    const viewSubmit = ({ updateView, record }) => {
      if (record.name != updateView.name && viewNameList.value.includes(updateView.name)) {
        message.error(t('视图名称已存在'));
        return;
      }
      if (record?.id) {
        const list = viewData.value.filter((item: any) => record?.id == item.id);
        if (updateView.is_submit?.[0]) {
          const view = {
            ...list[0].data,
            search_model: { ...props.currentViewObj.search_model, current: 1 },
            filter_map: props.currentViewObj.filter_map,
            sort_fields: props.currentViewObj.sort_fields,
            filtered_value: props.currentViewObj.filtered_value,
            sort_orders: props.currentViewObj.sort_orders,
            column: props.currentViewObj.column,
            isShowGeneralFilter: props.currentViewObj.isShowGeneralFilter,
            conditions: props.currentViewObj.conditions,
            group_condition: props.currentViewObj.group_condition,
            group_record: props.currentViewObj.group_record,
            default_search_condition_config_list: process_default_search_for_view(
              props.currentViewObj.default_search_condition_config_list,
            ),
          };
          delete view.is_system; // 存储时不记录is_system，防止后端直接修改，前端不起效
          update_view_settings({
            org_id: current_org.id,
            view_settings_id: record?.id,
            is_system: updateView.is_system?.[0],
            name: updateView.name,
            data: JSON.stringify(view),
          }).then((res: any) => {
            if (updateView.is_default?.[0]) {
              set_view_settings_default({
                org_id: current_org.id,
                view_settings_id: record?.id,
              }).then(() => {
                refresh_view_settings_cache({
                  org_id: current_org.id,
                  view_settings_id: record?.id,
                }).then(() => {
                  message.success(t('保存成功'));
                  if (res.id == props.currentViewObj?.id) {
                    emit('change', null, { ...res, ...res.data }, false, true);
                  } else {
                    viewData.value.forEach((item: any) => {
                      if (item.id == res.id) {
                        Object.assign(item, { ...res, ...res.data });
                      }
                    });
                  }
                  viewRefresh();
                });
              });
            } else {
              refresh_view_settings_cache({
                org_id: current_org.id,
                view_settings_id: record?.id,
              }).then(() => {
                message.success(t('保存成功'));
                if (res.id == props.currentViewObj?.id) {
                  emit('change', null, { ...res, ...res.data }, false, true);
                } else {
                  viewData.value.forEach((item: any) => {
                    if (item.id == res.id) {
                      Object.assign(item, { ...res, ...res.data });
                    }
                  });
                }
                viewRefresh();
              });
            }
          });
        } else {
          update_view_settings({
            org_id: current_org.id,
            view_settings_id: record?.id,
            is_system: updateView.is_system?.[0],
            name: updateView.name,
          }).then((res: any) => {
            if (updateView.is_default?.[0]) {
              set_view_settings_default({
                org_id: current_org.id,
                view_settings_id: record?.id,
              }).then(() => {
                refresh_view_settings_cache({
                  org_id: current_org.id,
                  view_settings_id: record?.id,
                }).then(() => {
                  message.success(t('保存成功'));
                  if (res.id == props.currentViewObj?.id) {
                    emit('change', null, { ...res, ...res.data }, false, true);
                  } else {
                    viewData.value.forEach((item: any) => {
                      if (item.id == res.id) {
                        Object.assign(item, { ...res, ...res.data });
                      }
                    });
                  }
                  viewRefresh();
                });
              });
            } else {
              refresh_view_settings_cache({
                org_id: current_org.id,
                view_settings_id: record?.id,
              }).then(() => {
                message.success(t('保存成功'));
                if (res.id == props.currentViewObj?.id) {
                  emit('change', null, { ...res, ...res.data }, false, true);
                } else {
                  viewData.value.forEach((item: any) => {
                    if (item.id == res.id) {
                      Object.assign(item, { ...res, ...res.data });
                    }
                  });
                }
                viewRefresh();
              });
            }
          });
        }
      } else {
        let view: any = {};
        if (updateView.is_submit?.[0]) {
          view = {
            search_model: { ...props.currentViewObj.search_model, current: 1 },
            filter_map: props.currentViewObj.filter_map,
            sort_fields: props.currentViewObj.sort_fields,
            filtered_value: props.currentViewObj.filtered_value,
            sort_orders: props.currentViewObj.sort_orders,
            column: props.currentViewObj.column,
            isShowGeneralFilter: props.currentViewObj.isShowGeneralFilter,
            conditions: props.currentViewObj.conditions,
            group_condition: props.currentViewObj.group_condition,
            group_record: props.currentViewObj.group_record,
            default_search_condition_config_list: process_default_search_for_view(
              props.currentViewObj.default_search_condition_config_list,
            ),
          };
          delete view.is_system; // 存储时不记录is_system，防止后端直接修改，前端不起效
        } else {
          view = {
            column: {},
            search_model: {},
            filter_map: {},
            sort_fields: [],
            filtered_value: {},
            sort_orders: [],
            isShowGeneralFilter: null,
            conditions: [],
            group_condition: {},
            group_record: {},
          };
        }
        create_view_settings({
          org_id: current_org.id,
          user_id: updateView.view_type == 'personal' ? userid : null,
          name: updateView.name,
          view_project__flag: env.VITE_APP_VIEW_PROJECT_FLAG,
          view_menu__flag: props.menu_flag,
          view_menu__name: props.menu_name,
          is_system: false,
          data: JSON.stringify(view),
        }).then((res: any) => {
          emit('change', null, { ...res, ...res.data }, true, true);
          if (res.id) {
            viewData.value = viewData.value.concat([
              {
                ...res,
              },
            ]);
            setCount([
              {
                id: res.id,
                search_model: view.search_model,
                filter_map: view.filter_map,
                sort_fields: view.sort_fields,
                group_condition: view.group_condition,
                conditions: view.conditions,
                isShowGeneralFilter: view.isShowGeneralFilter,
              },
            ]);
            window.location.hash = res.uid;
            handleHashChange(res.uid);
          }
        });
      }
    };
    // 视图编辑按钮
    const handleSubmit = (record: any, view_type: string) => {
      let is_submit: any = [false];
      if (props.currentViewObj.id == record.id) {
        is_submit = [true];
      }
      const tempModal = reactive({
        open: true,
        loading: false,
        title: t('编辑视图'),
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'vertical',
            col: [],
          },
          fields: [
            {
              type: 'input',
              name: 'name',
              label: t('视图名称'),
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: t('请输入视图名称'),
            },
            {
              type: 'checkbox',
              name: 'is_submit',
              label: '',
              disabled: false,
              allowClear: true,
              labelKey: 'name',
              valueKey: 'value',
              defaultValue: [false],
              placeholder: '',
            },
          ],
          rules: reactive({
            name: [
              {
                required: true,
                message: t('请输入视图名称'),
              },
            ],
          }),
          model: reactive({
            name: record.name,
            is_submit: is_submit,
            is_default: [record?.is_default ? record?.is_default : false],
            is_system: [record?.is_system ? record?.is_system : false],
          }),
        },
        options: {
          is_submit: [
            {
              name: t('将当前过滤条件、排序、显示属性、视图和分组等设置更新到该视图中'),
              value: true,
            },
          ],
          is_default: [
            {
              name: t('设为默认视图'),
              value: true,
            },
          ],
          is_system: [
            {
              name: t('设为系统视图'),
              value: true,
            },
          ],
        },
        ok: (data: any) => {
          return new Promise(function (resolve) {
            viewSubmit({ updateView: data, record: record });
            resolve(null);
          });
        },
      });
      if (view_type == 'public') {
        tempModal.form.fields.push({
          type: 'checkbox',
          name: 'is_default',
          label: '',
          disabled: false,
          allowClear: true,
          labelKey: 'name',
          valueKey: 'value',
          defaultValue: [false],
          placeholder: '',
        });
        if (is_auth.value) {
          tempModal.form.fields.push({
            type: 'checkbox',
            name: 'is_system',
            label: '',
            disabled: false,
            allowClear: true,
            labelKey: 'name',
            valueKey: 'value',
            defaultValue: [false],
            placeholder: '',
          });
        }
      }
      modalBox(tempModal);
    };
    // 添加视图
    const addView = (view_type: any) => {
      const tempModal = reactive({
        open: true,
        loading: false,
        title: t('新建视图'),
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'vertical',
            col: [],
          },
          fields: [
            {
              type: 'input',
              name: 'name',
              label: t('视图名称'),
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: t('请输入视图名称'),
            },
            {
              type: 'radio',
              name: 'view_type',
              label: t('视图可见范围'),
              disabled: false,
              allowClear: true,
              labelKey: 'name',
              valueKey: 'value',
              defaultValue: '',
              placeholder: '',
            },
            {
              type: 'checkbox',
              name: 'is_submit',
              label: '',
              disabled: false,
              allowClear: true,
              labelKey: 'name',
              valueKey: 'value',
              defaultValue: [false],
              placeholder: '',
            },
          ],
          rules: reactive({
            name: [
              {
                required: true,
                message: t('请输入视图名称'),
              },
            ],
          }),
          model: reactive({
            name: null,
            view_type: view_type,
            is_submit: [true],
          }),
        },
        options: {
          view_type: [
            { name: t('个人视图（仅自己可见）'), value: 'personal' },
            { name: t('公共视图（项目成员均可见）'), value: 'public' },
          ],
          is_submit: [
            {
              name: t('将当前过滤条件、排序、显示属性、视图和分组等设置更新到该视图中'),
              value: true,
            },
          ],
        },
        ok: (data: any) => {
          return new Promise(function (resolve) {
            if (viewNameList.value.includes(data.name)) {
              message.error(t('视图名称已存在'));
              return;
            }
            viewSubmit({ updateView: data, record: data });
            resolve(null);
          });
        },
      });
      modalBox(tempModal);
    };
    // 管理视图
    const editView = (view_type: any) => {
      const tempModal = reactive({
        open: true,
        component: 'ViewEditModal',
        compObj: {
          title: view_type == 'personal' ? t('个人视图管理') : t('公共视图管理'),
          data: view_type == 'personal' ? personData.value : publicData.value,
        },
        ok: (ids: any) => {
          if (ids && ids.length > 0) {
            change_view_settings_sort({
              org_id: current_org.id,
              view_settings_ids: ids,
            }).then(() => {
              message.success(t('保存成功'));
              viewRefresh();
            });
          } else {
            message.success(t('保存成功'));
            viewRefresh();
          }
        },
        cancel: (isEdit: any) => {
          if (isEdit) {
            viewRefresh();
          }
        },
      });
      modalBox(tempModal);
    };
    // 分享视图
    const handleShare = (record: any) => {
      let url = '';
      const index = window.location.href.indexOf('#');
      if (index !== -1) {
        // 如果找到了 #，则截取它之前的部分
        url = window.location.href.substring(0, index) + '#' + record.uid;
      } else {
        // 如果没有找到 #，则返回原始字符串
        url = window.location.href + '#' + record.uid;
      }
      copyValue({ val: url, message: t('复制成功') });
    };
    // 删除视图
    const handleDelet = (record: any) => {
      Modal.confirm({
        title: () =>
          `${t('确认删除此')}【${record.name}】${record?.user_id ? t('个人视图') : t('公共视图')}?`,
        content: t('视图删除后不可恢复，视图下工作项不受影响，是否确认删除？'),
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: t('确定'),
        onOk() {
          return new Promise(resolve => {
            delete_view_settings({
              org_id: current_org.id,
              view_settings_id: record?.id,
            })
              .then(() => {
                viewData.value = viewData.value.filter((item: any) => item.id != record.id);
                handleHashChange(null);
                message.success(t('删除成功'));
              })
              .finally(() => {
                resolve(null);
              });
          }).catch(() => console.log('Oops errors!'));
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onCancel() {},
      });
    };
    const getRequiredConditionObj = () => {
      const page_config = getPageConfig(props.app_flag, props.modalType, null, t, {
        use_store: true,
        to_i18n: true,
        enable_btn: false,
      });
      const required_condition = page_config.required_condition;
      const required_condition_obj = {};
      if (required_condition) {
        required_condition.forEach((item: any) => {
          const value = requiredConditionStore.value_map[item.key];
          if (value !== undefined && value !== null) {
            required_condition_obj[item.field_name] = value;
          }
        });
      }
      return required_condition_obj;
    };
    // 刷新Count (视图record，uid) => {}
    const refreshCount = (list: any) => {
      const count_search_list = [];
      list.forEach((item: any) => {
        let search_model: any = null;
        let filter_map: any = null;
        let group_condition: any = null;
        let conditions: any = null;
        if (item.data.isShowGeneralFilter) {
          search_model = {};
          filter_map = {};
          group_condition = item.data.group_condition;
          conditions = item.data.conditions;
        } else {
          search_model = item.data.search_model;
          filter_map = item.data.filter_map;
          group_condition = {};
          conditions = [];
        }

        count_search_list.push({
          id: item.id,
          search_model,
          filter_map,
          sort_fields: item.data.sort_fields,
          group_condition,
          conditions,
          isShowGeneralFilter: item.data.isShowGeneralFilter,
        });
      });
      setCount(count_search_list);
    };
    watch(
      () => props.current_num, // 监听保存当前视图
      () => {
        Modal.confirm({
          title: () => t('确定覆盖视图吗？'),
          content: t('当前视图原有的数据会被覆盖'),
          icon: () => createVNode(ExclamationCircleOutlined),
          okText: t('确定'),
          onOk() {
            return new Promise(resolve => {
              viewSubmit({
                updateView: {
                  is_submit: [true],
                  is_system: [props.currentViewObj.is_system],
                  name: props.currentViewObj.name,
                },
                record: props.currentViewObj,
              });
              resolve(null);
            }).catch(() => console.log('Oops errors!'));
          },
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onCancel() {},
        });
      },
    );
    watch(
      () => props.create_num, // 监听另存为
      () => {
        const tempModal = reactive({
          open: true,
          loading: false,
          title: t('新建视图'),
          form: {
            settings: {
              labelAlign: 'right',
              layout: 'vertical',
              col: [],
            },
            fields: [
              {
                type: 'input',
                name: 'name',
                label: t('视图名称'),
                disabled: false,
                allowClear: true,
                inputType: 'text',
                defaultValue: '',
                placeholder: t('请输入视图名称'),
              },
              {
                type: 'radio',
                name: 'view_type',
                label: t('视图可见范围'),
                disabled: false,
                allowClear: true,
                labelKey: 'name',
                valueKey: 'value',
                defaultValue: '',
                placeholder: '',
              },
            ],
            rules: reactive({
              name: [
                {
                  required: true,
                  message: t('请输入视图名称'),
                },
              ],
            }),
            model: reactive({
              name: null,
              view_type: 'personal',
              is_submit: [true],
            }),
          },
          options: {
            view_type: [
              { name: t('个人视图（仅自己可见）'), value: 'personal' },
              { name: t('公共视图（项目成员均可见）'), value: 'public' },
            ],
            is_submit: [
              {
                name: t('将当前过滤条件、排序、显示属性、视图和分组等设置更新到该视图中'),
                value: true,
              },
            ],
          },
          ok: (data: any) => {
            return new Promise(function (resolve) {
              const viewNameList = viewData.value.map((item: any) => item.name);
              if (viewNameList.includes(data.name)) {
                message.error(t('视图名称已存在'));
                return;
              }
              viewSubmit({ updateView: data, record: data });
              resolve(null);
            });
          },
        });
        modalBox(tempModal);
      },
    );

    watch(
      () => props.count_num, // 监听刷新当前视图count
      () => {
        refreshCount(viewData.value);
      },
    );
    const handleRequiredConditionChange = (key: string) => {
      const page_config = getPageConfig(props.currentViewObj.app_flag, props.modalType, null, t, {
        use_store: true,
        to_i18n: true,
        enable_btn: false,
      });
      if (page_config.required_condition) {
        const item = page_config.required_condition.find((item: any) => item.key === key);
        if (item) {
          viewRefresh();
        }
      }
    };
    onMounted(() => {
      viewRefresh();
      required_condition_event_obj().on('change', handleRequiredConditionChange);
    });
    onUnmounted(() => {
      required_condition_event_obj().off('change', handleRequiredConditionChange);
    });
    // 页面重新进入刷新count
    onActivated(() => {
      refreshCount(viewData.value);
    });
    return {
      props,
      viewKey,
      customStyle,
      columns,
      personData,
      publicData,
      is_auth,
      addView,
      editView,
      customRow,
      changeView,
      handleSubmit,
      handleShare,
      handleDelet,
      appStore,
    };
  },
});
</script>
<style lang="less">
.collapses .ant-collapse-item .ant-collapse-content .ant-collapse-content-box {
  padding: 0;
}

.num {
  display: inline-block;
}

.dropdown {
  display: none;
}

.table:hover .dropdown {
  display: inline-block;
}

.table:hover .num {
  display: none;
}
</style>
